module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg7-f1c2efd8d65924449a8a7a2fc3a2a3b9.svg";